import {
  Box,
  LinearProgress,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import type { PlatformPoliciesRow } from "../../hooks/usePlatformPoliciesTableData";

export const PlatformPoliciesTableComplianceCell: GridColDef<PlatformPoliciesRow>["renderCell"] =
  ({ row }) => {
    const compliance = row.policyCompliance;
    const theme = useTheme();

    if (compliance == null) {
      return (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            No Data
          </Typography>
        </Box>
      );
    }

    const tooltipTitle = `${row.findingStatsPass ?? 0} / ${row.findingStatsTotal ?? 0} findings (${compliance}%)`;

    return (
      <Tooltip title={tooltipTitle} placement="top" arrow>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            height: "100%",
          }}
        >
          <LinearProgress
            variant="determinate"
            value={compliance}
            sx={{
              width: "100%",
              height: 8,
              borderRadius: 1,
              backgroundColor:
                theme.palette.mode === "light" ? "#E0E0E0" : "#333333",
              "& .MuiLinearProgress-bar": {
                background: `linear-gradient(to left, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} ${compliance}%)`,
                borderRadius: 0.6,
              },
            }}
          />
        </Box>
      </Tooltip>
    );
  };
